module.exports = __webpack_public_path__ + "img/user-avatar-6.f78c090d.png";